// extracted by mini-css-extract-plugin
module.exports = {"mergeBtn":"mergeBtn--0ACk+","mergeRow":"mergeRow--xyU5B"};